import React, { FC } from 'react';
import classNames from 'classnames';

import { IconButtonProps } from './IconButton.types';
import Icon from '../../icon/Icon';

import './IconButton.scss';

const IconButton: FC<IconButtonProps> = ({ icon, ...props }) => (
  <button
    {...props}
    className={classNames('react-icon-button', props.className)}
    type="button"
  >
    <Icon name={icon} />
  </button>
);

export default IconButton;
